import { render, staticRenderFns } from "./inner.vue?vue&type=template&id=11dd8856&"
import script from "./inner.vue?vue&type=script&lang=ts&"
export * from "./inner.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports